import { booleanAttribute, Directive, input } from '@angular/core';

@Directive({
    selector: '[qpxHeaderLabel]',
})
export class QpxHeaderLabel {
    public readonly interactive = input(false, { transform: booleanAttribute });
}
